// extracted by mini-css-extract-plugin
module.exports = {"rentStrikeColor":"#c92a1d"};